import { render, staticRenderFns } from "./CertificationsCreateEdit.vue?vue&type=template&id=043aa09c"
import script from "./CertificationsCreateEdit.vue?vue&type=script&lang=js"
export * from "./CertificationsCreateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports